export const READINESS_FACTOR_TYPE = {
  Win32Matched: 'Win32Matched',
  Win32Unmatched: 'Win32Unmatched',
};

const READINESS_FACTOR_TYPE_MAPPING = [
  { value: READINESS_FACTOR_TYPE.Win32Matched, label: 'Win32 Matched' },
  { value: READINESS_FACTOR_TYPE.Win32Unmatched, label: 'Win32 Unmatched' },
];

export const getReadinessFactorTypeLabel = value =>
  READINESS_FACTOR_TYPE_MAPPING.find(item => item.value === value)?.label || 'Readiness Factor';
